// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__50Lcv","description":"Hero_description__zRI6x","downloadApp":"Hero_downloadApp__qMXJi","expandButton":"Hero_expandButton__d7OCg"};